import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-image-full.component.scss';
import Slider from '../slider/slider.component';
var BannerHeroImageFull = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroImageFull, _super);
    function BannerHeroImageFull(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroImageFull.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerHeroImageFull.prototype.bindEvents = function () { };
    return BannerHeroImageFull;
}(Base));
export { BannerHeroImageFull };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full/banner-hero-image-full.component.ts
// module id = 131
// module chunks = 0